// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ChakraProvider, defaultSystem } from '@chakra-ui/react';
import { ToastContainer } from 'react-toastify';
import { ColorModeProvider } from './components/ui/color-mode';
import Auth0ProviderWithNavigate, {
  getPlaywrightAuth0Mock,
} from './auth/Auth0ProviderWithNavigate';

const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN;
const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const auth0Audience = process.env.REACT_APP_AUTH0_AUDIENCE;
const hasPlaywrightAuth0Mock = Boolean(getPlaywrightAuth0Mock());

if (!hasPlaywrightAuth0Mock && (!auth0Domain || !auth0ClientId || !auth0Audience)) {
  console.error('Auth0 environment variables (REACT_APP_AUTH0_DOMAIN, REACT_APP_AUTH0_CLIENT_ID, REACT_APP_AUTH0_AUDIENCE) are missing!');
}

const rootElement = document.getElementById('root');
if (
  rootElement?.dataset?.prerenderedHomepage === 'true'
  || rootElement?.dataset?.prerenderedStockPage === 'true'
) {
  rootElement.replaceChildren();
  delete rootElement.dataset.prerenderedHomepage;
  delete rootElement.dataset.prerenderedStockPage;
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0ProviderWithNavigate>
        <ChakraProvider value={defaultSystem}>
          <ColorModeProvider>
            <App />
          </ColorModeProvider>
          <ToastContainer />
        </ChakraProvider>
      </Auth0ProviderWithNavigate>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
